// extracted by mini-css-extract-plugin
export default {"employees_buttons":"workersList_employees_buttons__2HPLx","copy_title":"workersList_copy_title__BW1nn","copy_block":"workersList_copy_block__Z-Pew"};